'use client';

import { IconButton, TextButton } from '@yanolja-rnd/nol-design-system';
import { IcClose } from '@yanolja-rnd/nol-icons';
import { type FC } from 'react';

import Modal from 'react-modal';

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CategoryModal: FC<CategoryModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      ariaHideApp={false}
      closeTimeoutMS={210}
      isOpen={isOpen}
      className={{
        afterOpen: 'animate-modalOpen',
        base: 'h-full w-full translate-y-[100%]',
        beforeClose: '!animate-modalClose',
      }}
      overlayClassName={{
        afterOpen: 'animate-overlayOpen',
        base: 'fixed opacity-0 inset-0 bg-scrim z-high left-1/2 -translate-x-1/2 max-w-mobile-size pc:max-w-[none] w-full',
        beforeClose: '!animate-overlayClose',
      }}
      onRequestClose={onClose}>
      <div className="flex h-full flex-col bg-static-white">
        <header className="z-[1] min-h-48 border-b border-line-neutral-weak1 pl-6 pr-16">
          <div className="relative mx-auto my-0 flex max-w-legacy-pc-size items-center">
            <div className="absolute">
              <IconButton icon={<IcClose />} size="medium" theme="ghost" onClick={onClose} />
            </div>
            <h1 className="mb-10 mt-13 block w-full text-center typography-subtitle-18-bold">지역 선택</h1>
            <TextButton
              mobileSize="medium"
              pcSize="medium"
              className="flex shrink-0 text-[#0152cc]"
              onClick={() => {
                window.location.href = '/leisure/list';
              }}>
              상품 전체보기
            </TextButton>
          </div>
        </header>
        <div className="flex-grow">
          <iframe
            src={`${process.env.NEXT_PUBLIC_YANOLJA_ORIGIN}/leisure/all-categories-iframe`}
            title="지역 선택"
            className="h-full w-full"
          />
        </div>
      </div>
    </Modal>
  );
};
